// extracted by mini-css-extract-plugin
export default {"fullWidth":"aH-z","image":"bH-z","lazyLoadPicture":"cH-z","lazyLoadSpinner":"dH-z","lazyLoadSpin":"eH-z","lazyLoadImage":"fH-z","hasStyledAspectRatio":"gH-z"};